import React from 'react';
import { Link } from 'react-router-dom';
import AuthPageShell from '../../../components/AuthPageShell';
import MarketingBrand from '../../marketing/components/MarketingBrand';
import LoginPage from './LoginPage';

const LoginRoutePage: React.FC = () => (
  <AuthPageShell>
    <div className="cp-auth-panel">
      <div className="cp-auth-panel__brand">
        <MarketingBrand />
      </div>
      <LoginPage lead="Use the email and password for your approved organization." />
      <p className="cp-auth-panel__footer">
        Need access?{' '}
        <Link to="/signup">Request organization access</Link>
      </p>
    </div>
  </AuthPageShell>
);

export default LoginRoutePage;
